export default __webpack_public_path__ + "static/media/comfy1.286318f6.861aed60.png";